import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { AktifKullaniciBilgisi } from './AktifKullaniciBilgisi';
import { KULLANICI } from './KULLANICI';
import { FaturaTipleri } from '@core/genel/AppEnums';
import { AktifFaturaBilgisi } from '@core/models/AktifFaturaBilgisi';
import { HashingHelperService } from '@core/utils/hashing.helper.service';
import { LayoutUtilsService, MessageType } from '@core/utils/layout-utils.service';

@Injectable()
export class AktifKullaniciBilgisiService {

    public KULLANICI: KULLANICI;
    aktifKullaniciBilgisi: AktifKullaniciBilgisi = new AktifKullaniciBilgisi();
    aktifKullaniciBilgisi$: BehaviorSubject<AktifKullaniciBilgisi>;

    aktifFaturaBilgisi: AktifFaturaBilgisi = new AktifFaturaBilgisi();
    aktifFaturaBilgisi$: BehaviorSubject<AktifFaturaBilgisi>;

    constructor(
        private srvUS: LayoutUtilsService,
        private hashingHelper: HashingHelperService
    ) {
        this.aktifKullaniciBilgisi$ = new BehaviorSubject(this.aktifKullaniciBilgisi);
        this.aktifKullaniciBilgisiniDoldur();
        this.aktifFaturaBilgisiniDoldur();
    }

    /**
     * Kullanıcı token bilgisini döndürür
     * @returns {Observable<string>}
     */
    public getKullaniciToken(): Observable<string> {
        let token: string;
        if (this.aktifKullaniciBilgisi) {
            token = this.aktifKullaniciBilgisi.TOKEN;
        }
        return of(token);
    }

    /**
     * KullanıcıId değerini döndürür
     * @returns {Observable<number>}
     */
    public getKullaniciId(): Observable<number> {
        let kullaniciID: number;
        if (this.aktifKullaniciBilgisi) {
            kullaniciID = this.aktifKullaniciBilgisi.ID;
        }
        return of(kullaniciID);
    }

    /**
     * Aktif kullanıcı bilgisini döndürür
     * @returns {Observable<number>}
     */
    public getAktifKullaniciBilgisi(): Observable<AktifKullaniciBilgisi> {
        let aktifKullaniciBilgisi = new AktifKullaniciBilgisi();
        if (this.aktifKullaniciBilgisi) {
            aktifKullaniciBilgisi = this.aktifKullaniciBilgisi;
        }
        this.aktifKullaniciBilgisi$.next(this.aktifKullaniciBilgisi);
        return of(aktifKullaniciBilgisi);
    }

    public aktifKullaniciBilgisiniSifirla(): void {
        this.aktifKullaniciBilgisi.KLNC_ADI = '';
        this.aktifKullaniciBilgisi.KLNC_EMAIL = '';
        this.aktifKullaniciBilgisi.KLNC_CEP_TEL = '';
        this.aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL = '';
        this.aktifKullaniciBilgisi.KLNC_AD_SOYAD = '';
        this.aktifKullaniciBilgisi.TOKEN = '';
        this.aktifKullaniciBilgisi.KLNC_YETKILI_MI = false;
        this.aktifKullaniciBilgisi.ID = 0;
        this.aktifKullaniciBilgisi.KLNC_YETKI_INFO = [];
        this.aktifKullaniciBilgisi.LISANS_FATURA_TIPI_IDS = [];
        this.aktifKullaniciBilgisi.AVATAR = '';
        this.aktifKullaniciBilgisi.KLNC_BR_ID = 0;
        this.aktifKullaniciBilgisi.KLNC_CLIENT_ID = 0;
        this.aktifKullaniciBilgisi.KLNC_LGN_TYP_ID = 0;
        this.aktifKullaniciBilgisi.TALEP_YETKILISI_MI = false;
        this.aktifKullaniciBilgisi.KLNC_BURO_UNVAN = '';
        localStorage.removeItem('a');
        this.aktifKullaniciBilgisi$.next(this.aktifKullaniciBilgisi);
    }

    public aktifKullaniciResimBilgisiniYenile(avatar: any): void {
        if (this.aktifKullaniciBilgisi) {
            this.aktifKullaniciBilgisi.AVATAR = avatar;
        }
        var aktifKullaniciBilgisi = JSON.parse(this.hashingHelper.decrypt(localStorage.getItem('a')));

        this.aktifKullaniciBilgisi$.next(this.aktifKullaniciBilgisi);
    }

    public aktifKullanıcıTelefonBilgisiniYenile(ikinciCepTel: string) {
        if (this.aktifKullaniciBilgisi) { this.aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL = ikinciCepTel; }
        this.aktifKullaniciBilgisi$.next(this.aktifKullaniciBilgisi);
    }

    public aktifKullaniciBilgisiniDoldur(): void {
        if (localStorage.getItem("a") === null || localStorage.getItem("a") === 'undefined') {
            this.aktifKullaniciBilgisiniSifirla();
        }
        else {
            let aktifKullaniciBilgisi = JSON.parse(this.hashingHelper.decrypt(localStorage.getItem("a")));

            if (aktifKullaniciBilgisi) {
                if (aktifKullaniciBilgisi.WEB_SERVIS) {
                    this.srvUS.showActionNotification("Giriş yapmak istediğiniz kullanıcı web servis kullanıcısı olduğundan dolayı tarayıcıdan giriş yapamazsınız.", MessageType.Info);
                    return;
                }

                this.aktifKullaniciBilgisi.KLNC_ADI = aktifKullaniciBilgisi.KLNC_ADI;
                this.aktifKullaniciBilgisi.KLNC_EMAIL = aktifKullaniciBilgisi.KLNC_EMAIL;

                if (aktifKullaniciBilgisi.KLNC_CEP_TEL)
                    this.aktifKullaniciBilgisi.KLNC_CEP_TEL = aktifKullaniciBilgisi.KLNC_CEP_TEL.length < 11 ? 0 + aktifKullaniciBilgisi.KLNC_CEP_TEL : aktifKullaniciBilgisi.KLNC_CEP_TEL;

                if (aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL)
                    this.aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL = aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL.length < 11 ? 0 + aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL : aktifKullaniciBilgisi.KLNC_IKINCI_CEP_TEL;

                this.aktifKullaniciBilgisi.ID = aktifKullaniciBilgisi.ID;
                this.aktifKullaniciBilgisi.AVATAR = aktifKullaniciBilgisi.AVATAR;
                this.aktifKullaniciBilgisi.TOKEN = aktifKullaniciBilgisi.TOKEN;
                this.aktifKullaniciBilgisi.KLNC_AD_SOYAD = aktifKullaniciBilgisi.KLNC_AD_SOYAD;
                this.aktifKullaniciBilgisi.KLNC_YETKILI_MI = aktifKullaniciBilgisi.KLNC_YETKILI_MI;
                this.aktifKullaniciBilgisi.KLNC_YETKI_INFO = aktifKullaniciBilgisi.KLNC_YETKI_INFO;
                this.aktifKullaniciBilgisi.KLNC_BR_ID = aktifKullaniciBilgisi.KLNC_BR_ID;
                this.aktifKullaniciBilgisi.KLNC_CLIENT_ID = aktifKullaniciBilgisi.KLNC_CLIENT_ID;
                this.aktifKullaniciBilgisi.KLNC_LGN_TYP_ID = aktifKullaniciBilgisi.KLNC_LGN_TYP_ID;
                this.aktifKullaniciBilgisi.KLNC_TYP_ID = aktifKullaniciBilgisi.KLNC_TYP_ID;
                this.aktifKullaniciBilgisi.LISANS_FATURA_TIPI_IDS = aktifKullaniciBilgisi.LISANS_FATURA_TIPI_IDS;
                this.aktifKullaniciBilgisi.TALEP_YETKILISI_MI = aktifKullaniciBilgisi.TALEP_YETKILISI_MI;
                if (aktifKullaniciBilgisi.KLNC_LGN_TYP_ID == 1) {
                    this.aktifKullaniciBilgisi.KLNC_BURO_UNVAN = aktifKullaniciBilgisi.KLNC_BURO_UNVAN;
                } else {
                    this.aktifKullaniciBilgisi.KLNC_BURO_UNVAN = "";
                }

            }
        }
        this.aktifKullaniciBilgisi$.next(this.aktifKullaniciBilgisi);
    }

    public aktifFaturaBilgisiniSifirla(): void {
        this.aktifFaturaBilgisi.FATURA_TIPI_ID = 0;
        localStorage.removeItem('AktifFaturaBilgisi');
    }

    public aktifFaturaBilgisiniKaydet(faturaTipi: FaturaTipleri): void {
        if (faturaTipi) {
            this.aktifFaturaBilgisi.FATURA_TIPI_ID = faturaTipi;
            localStorage.setItem('AktifFaturaBilgisi', JSON.stringify(this.aktifFaturaBilgisi));
        }
    }

    public aktifFaturaBilgisiniDoldur(): void {
        let aktifFaturaBilgisi = JSON.parse(localStorage.getItem("AktifFaturaBilgisi"));
        if (aktifFaturaBilgisi) {
            this.aktifFaturaBilgisi.FATURA_TIPI_ID = aktifFaturaBilgisi.FATURA_TIPI_ID;
        }
    }

    public yetkisiVarMi(KontroNoktasiAdi: string): boolean {
        if (!(this.aktifKullaniciBilgisi.KLNC_YETKI_INFO.length > 0) || KontroNoktasiAdi == "" || KontroNoktasiAdi == null || KontroNoktasiAdi === undefined)
            return;

        for (let yetkiIndex = 0; yetkiIndex < this.aktifKullaniciBilgisi.KLNC_YETKI_INFO.length; yetkiIndex++) {
            const yetki = this.aktifKullaniciBilgisi.KLNC_YETKI_INFO[yetkiIndex];
            if (yetki.KONTROL_NOKTASI_ADI == KontroNoktasiAdi) {
                return true;
            }
        }
        return false;
    }
}